module.exports = __webpack_public_path__ + "static/img/879fe74.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/appxz/title.png
// module id = 622
// module chunks = 2